import { render, staticRenderFns } from "./use-wallet.vue?vue&type=template&id=26f0b95b&"
import script from "./use-wallet.vue?vue&type=script&lang=js&"
export * from "./use-wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports